import React, { useState } from "react";

import { message, Upload, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import Modal from "../../components/modal/DraggableModal"   // talabnoma §8.2 (2026-09-06): siljitiladigan modal
import { Inbox } from "react-feather";
import { useTranslation } from "react-i18next";

export interface IUploadOptions {
  onOk: (obj: File) => void;
  onCancel: () => void;
  sampleDate: object;
  visible: boolean;
  /** tog'a #2892: foydalanuvchiga ko'rsatiladigan ustun nomlari va shablon yuklab olish */
  columnsHint?: string[];
  onTemplate?: () => void | Promise<void>;
}

export default function UploadExcelModal({
  onOk,
  onCancel,
  sampleDate,
  visible,
  columnsHint,
  onTemplate,
}: IUploadOptions) {
  const [file, setFile] = useState<File | null>(null);
  const [tplLoading, setTplLoading] = useState(false);
  const { t } = useTranslation();

  function handleOk() {
    if (!file) {
      message.error(t("fileNotUploaded"));
      return;
    }
    onOk(file);
  }

  function handleBeforeUpload(file: File) {
    // Boshliq 2026-09-29 (import qo'llanmasi): «.XLSX» (katta harf) va eski «.xls» ham qabul qilinadi — SheetJS ikkalasini o'qiydi
    const isExcel = /\.(xlsx|xls|csv)$/i.test(file.name);
    if (!isExcel) {
      message.error(`${file.name} ${t("notAllowed")}`);
      return Upload.LIST_IGNORE;
    }
    message.success(`${file.name} ${t("fileUploaded")}`);
    setFile(file);

    //don't send xrh request
    return false;
  }

  async function shablon() {
    if (!onTemplate) return;
    setTplLoading(true);
    try {
      await onTemplate();
    } catch (e: any) {
      message.error(e?.message || t("error"));
    } finally {
      setTplLoading(false);
    }
  }

  return (
    <Modal
      destroyOnClose
      okText={t("import")}
      cancelText={t("cancel")}
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}>
      {onTemplate && (
        <Button icon={<DownloadOutlined />} loading={tplLoading} onClick={shablon} data-testid="import-template" style={{ marginTop: 8 }}>
          {t("importTemplate")}
        </Button>
      )}
      <Upload.Dragger
        style={{ marginTop: onTemplate ? "16px" : "30px" }}
        name="file"
        accept=".csv, .xlsx, .xls"
        multiple={false}
        onRemove={() => setFile(null)}
        beforeUpload={handleBeforeUpload}>
        <p className="ant-upload-drag-icon">
          <Inbox size="40" />
        </p>
        <p className="ant-upload-text">{t("clickOrDragToUpload")}</p>
        <p className="ant-upload-hint" style={{ whiteSpace: "pre-line" }}>
          {t("uploadInfo", { keys: (columnsHint || Object.keys(sampleDate)).join("\n") })}
        </p>
      </Upload.Dragger>
    </Modal>
  );
}
